export class Conditions {
  static Item_Name = 'ITEM:NAME';
  static Item_Value = 'ITEM:VALUE';
  static Item_Quantity = 'ITEM:QUANTITY';
  static Item_Sku = 'ITEM:SKU';
  static Item_Weight = 'ITEM:WEIGHT';
  static Item_Height = 'ITEM:HEIGHT';
  static Item_Length = 'ITEM:LENGTH';
  static Item_Width = 'ITEM:WIDTH';
  static Item_Service = 'ITEM:SERVICE';
  static Item_EBayService = 'ITEM:EBAYSERVICE';
  static Item_MarketplaceService = 'ITEM:MARKETPLACESERVICE';
  static Item_Source = 'ITEM:SOURCE';
  static Item_Package = 'ITEM:PACKAGE';
  static Item_TariffCode = 'ITEM:TARIFFCODE';
  static Recipient_Country = 'RECIPIENT:COUNTRY';
  static Recipient_Email = 'RECIPIENT:EMAIL';
  static Recipient_Phone = 'RECIPIENT:PHONE';
  static Recipient_BuyerId = 'RECIPIENT:BUYERID';
  static Item_SoldDay = 'ITEM:SOLDDAY';
}
